import React from 'react';
import {Row, Col, Button} from "react-bootstrap";
import Card from "../../Card";
import {withRouter} from "react-router";
import GoogleAnalyticsUtils from "../../../util/GoogleAnalyticsUtils";
import YouTube from "react-youtube";
import {faReddit, faGithub} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {BrowserView, MobileView} from "react-device-detect";
import { faMugHot } from '@fortawesome/free-solid-svg-icons';

class Welcome extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        GoogleAnalyticsUtils.pageview(window.location.pathname + window.location.search);
    }

    renderButton() {
        return (
            <>
                <BrowserView>
                    <Button variant={"customPrimary"}
                            onClick={() => {this.props.history.push("/launch")}}
                            disabled={!(this.props.videoReady && this.props.cvReady)}>시작하기</Button>
                    { !this.props.videoReady ?
                        <p style={{fontSize: "80%"}}>웹캠 입력 대기중...</p>
                        : !this.props.cvReady ?
                            <p style={{fontSize: "80%"}}>로딩 중...</p>
                            :
                            null
                    }
                </BrowserView>
                <MobileView>
                    <p>Note: Take Aim은 모바일 기기와 호환되지 않습니다.</p>
                </MobileView>
            </>
        )
    }

    render() {
        return (
            <>
                <Row>
                    <Col sm={12} md={{span: 6, offset: 3}} className={"text-center"}>
                        <h3>Take Aim(ZEROPOINT ver)</h3>
                        <>
                            <p>
                            Take Aim은 유일한 오픈 소스 웹 기반 레이저 사격 시스템입니다. 레이저 카트리지 또는 레이저 총과 함께 노트북, 웹캠, 프로젝터를 사용하여 시작할 수 있습니다.
                            </p>
                        </>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className={"text-center"}>
                        {this.renderButton()}

                        <hr />
                    </Col>
                </Row>
                <Row className={"text-center"} style={{borderTop: "1px solid white", paddingTop: "10px"}}>
                    <Col sm={12}>
                        <h3>About Take Aim</h3>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} className={"text-center"}>
                    <h4 style={{textDecoration: "underline"}}>데모 영상</h4>
                    <div style={{overflowX: "scroll"}}>
                        <YouTube videoId={"YH3_XY4QLIs"} />
                    </div>
                    </Col>
                </Row>
                <Row className={"text-center"} style={{marginTop: "20px"}}>
                    <Col sm={12}>
                        <h4  style={{textDecoration: "underline"}}>기능</h4>
                    </Col>
                </Row>
                <Row className={"text-center"}>
                    <Col sm={4} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>실시간 사격 판정</h5>
                            <p>Take Aim을 사용하면 사격할 때마다 즉각적인 피드백을 받을 수 있습니다.</p>
                        </Card>
                    </Col>
                    <Col sm={4} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>사격 타이머</h5>
                            <p>Take Aim의 사격 타이머는 사격 속도를 알려줍니다. 이것을 사용하여 드로우에서 첫 사격까지의 시간을 측정하세요.</p>
                        </Card>
                    </Col>
                    <Col sm={4} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>프로젝터 타겟</h5>
                            <p>이제 벽에 타겟을 붙일 필요가 없습니다! Take Aim이 자동으로 벽에 타겟을 투영해 줍니다!</p>
                        </Card>
                    </Col>
                </Row>
                <Row className={"text-center"} style={{marginTop: "20px"}}>
                    <Col sm={12}>
                        <h4  style={{textDecoration: "underline"}}>필수 사항</h4>
                        <p>시작하려면 다음이 필요합니다:</p>
                    </Col>
                </Row>
                <Row className={"text-center"}>
                    <Col sm={3} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>웹캠</h5>
                            <p>외장 웹캠을 사용하는 것이 가장 좋습니다. 만약 없다면 스마트폰을 외장 웹캠으로 사용할 수 있게 해주는 앱을 활용할 수도 있습니다.</p>
                        </Card>
                    </Col>
                    <Col sm={3} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>레이저 카트리지</h5>
                            <p>어떤 레이저 카트리지나 레이저 건이든 사용할 수 있습니다.</p>
                        </Card>
                    </Col>
                    <Col sm={3} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>프로젝터</h5>
                            <p>어떤 프로젝터라도 사용 가능하지만, 단초점 프로젝터가 가장 적합합니다.</p>
                        </Card>
                    </Col>
                    <Col sm={3} style={{paddingBottom: "10px"}}>
                        <Card style={{height: "100%"}}>
                            <h5>컴퓨터</h5>
                            <p>윈도우, 리눅스, 맥 어떤 운영체제든 상관없습니다! Take Aim은 웹 기반이니까요!</p>
                        </Card>
                    </Col>
                </Row>
                <Row className={"text-center"} style={{marginTop: "20px"}}>
                    <Col sm={12}>
                        <h4  style={{textDecoration: "underline"}}>Find Us</h4>
                    </Col>
                </Row>
                <Row className={"text-center"} >
                    <Col sm={6} md={{span: 3, offset: 3}} className={"text-center"}  style={{paddingBottom: "10px"}}>
                        <Card>
                            <a href={"https://cafe.naver.com/zepo"} style={{fontSize: "150%", color: "white"}}>
                            <FontAwesomeIcon icon={faMugHot} /> Naver Cafe
                            {/* <img src={"/logo.svg"} style={{height: "100px", marginBottom: "10px"}}/> */}
                                {/* <FontAwesomeIcon icon={faReddit} /> */}
                            </a>
                        </Card>
                    </Col>
                    <Col sm={6} md={{span: 3, offset: 0}} className={"text-center"} style={{paddingBottom: "10px"}}>
                        <Card>
                            <a href={"https://www.github.com/dbecker1/take-aim"} style={{fontSize: "150%", color: "white"}}>
                                <FontAwesomeIcon icon={faGithub} /> Github
                            </a>
                        </Card>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} className={"text-center"}>
                        {this.renderButton()}
                    </Col>
                </Row>

            </>
        );
    }

}

export default withRouter(Welcome);